module.exports = __webpack_public_path__ + "media/images/dime-icon-8c1d616e42e2e629caa146fd02d08cd8.svg";